export const TRANSLATION_PREFIX = 'number_details.settings.call_distribution_section.diagram';
